import { createAsyncThunk } from '@reduxjs/toolkit';
import api, { handleApiError } from 'state/api';

export const getMarketplacesApi = createAsyncThunk(
  'marketplaces/getMarketplacesApi',
  async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const response = await api.get(`marketplaces?page=${page}&limit=${limit}`);
      return response.data.success ? response.data.data : response.data;
    } catch (error) {
      return handleApiError('getMarketplacesApi', error, rejectWithValue);
    }
  },
);

export const getMarketplaceApi = createAsyncThunk(
  'marketplaces/getMarketplace',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`marketplaces/${id}`);
      return response.data.success ? response.data.data : response.data;
    } catch (error) {
      return handleApiError('getMarketplaceApi', error, rejectWithValue);
    }
  },
);

export const updateMarketplaceApi = createAsyncThunk(
  'marketplaces/updateMarketplace',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await api.put(`marketplaces/${id}`, data);
      return response.data;
    } catch (error) {
      return handleApiError('updateMarketplaceApi', error, rejectWithValue);
    }
  },
);

export const getMarketplacesListApi = createAsyncThunk(
  'marketplaces/getMarketplacesList',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('marketplaces/list');
      return response.data.success ? response.data.data : response.data;
    } catch (error) {
      return handleApiError('getMarketplacesListApi', error, rejectWithValue);
    }
  },
);

export const getMarketplaceRateLimitApi = createAsyncThunk(
  'marketplaces/getMarketplaceRateLimit',
  async ({ marketplace, storeId }, { rejectWithValue }) => {
    try {
      const response = await api.get(`marketplaces/${marketplace}/rate-limit/${storeId}`);
      if (!response.data.success) {
        return rejectWithValue(
          response.data?.error || response.data?.message || 'Failed to load rate limit',
        );
      }
      return response.data.data;
    } catch (error) {
      return handleApiError('getMarketplaceRateLimitApi', error, rejectWithValue);
    }
  },
);
